export default "__VITE_ASSET__BtXA_vuo__"